import {Component, Signal} from '@angular/core';
import {ProjectBaseStepComponent} from '../../pages/customer/project-sequence/project-base-step/project-base-step.component';
import {createTabManagementSignals} from './tab-utils';

@Component({
  selector: 'app-multi-tab-step-base',
  template: '',
})
export abstract class MultiTabStepBaseComponent extends ProjectBaseStepComponent {
  protected readonly tabManagement = createTabManagementSignals();

  get activeTabIndex(): Signal<number> {
    return this.tabManagement.activeTabIndex.asReadonly();
  }

  get loadedTabs(): Signal<Set<number>> {
    return this.tabManagement.loadedTabs.asReadonly();
  }

  onTabChange(tabIndex: string | number): void {
    this.tabManagement.onTabChange(tabIndex);
  }
}
